module.exports = __webpack_public_path__ + "img/button-navmenu.bfc36563.svg";